import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class CriarSenhaTemporariaService {

  constructor(
    private httpService: HttpService
  ) { }
   
  returnClient(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/temporarypassword/returnClient', data, successHandle, errorHandle);

  }

  newTemporaryPassword(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doPost('/temporarypassword/newTemporaryPassword', data, successHandle, errorHandle);

  }
 
}
